import React from 'react';

function Input({
  style,
  ...props
}){
  return (
    <input 
      type="text"
      style={{
        padding: '9px 10px',
        margin: '10px 5px',
        borderRadius: '5px',
        border: '1px solid #979797',
        outline: 'none',
        width: '100%',
        ...style
      }}
      {...props}
    />
  );
}

export default Input;